import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class CustomLoader extends Vue {
    @Prop({ type: String, default: 'primary' })
    public color: string;

    @Prop({ type: Boolean, default: false })
    public fullPage: string;
}
